<template>
  <Modal
    :modal="modal"
    :titleIcons="[]"
    title="Enviar E-mail"
    @close="$emit('close')"
    @save="save"
    :loading="loading"
  >
    <v-form v-model="valid" @submit.prevent="save">
      <template v-if="emails.length > 1">
        <v-checkbox
          class="mt-0"
          :class="{ 'mt-3': i === emails.length - 1 }"
          v-model="emailsSelected"
          v-for="(email, i) of emails"
          :key="i"
          hide-details
          :label="email.email"
          :value="email.email"
        ></v-checkbox>
      </template>
      <v-text-field
        v-else
        v-model="email"
        label="Email"
        type="email"
        :autofocus="modal"
      ></v-text-field>
    </v-form>
  </Modal>
</template>

<script>
import Modal from '@/components/shared/Modal';

export default {
  name: 'ModalEmail',
  props: {
    modal: {
      type: Boolean,
      default: false
    },
    emails: {
      type: Array,
      default: () => []
    },
  },
  components: {
    Modal
  },
  data: () => ({
    loading: false,
    valid: true,
    emailsSelected: [],
    email: '',
    rules: {
      required: v => !!v || 'Campo obrigatório'
    }
  }),
  watch: {
    modal(value) {
      if (!value) this.email = '';
      if (value && this.emails.length === 1) this.email = this.emails[0].email;
    },
  },
  methods: {
    save() {
      if (this.email) this.emailsSelected.push(this.email);
      this.$emit('save', this.emailsSelected);
    }
  }
}
</script>

<style>

</style>